export enum StateFilter {
  active = "active",
  inactive = "inactive"
}
